export const NAMESPACE = 'KanBo/Home/unreadBoardActivitiesCount/'
export const SET = NAMESPACE + 'SET'

const initialState = { }

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET: {
      return {
        ...state,
        [action.payload.id]: action.payload.count
      }
    }
    default: return state
  }
}

export function set ({ id, count }) {
  return {
    type: SET,
    payload: {
      id,
      count,
    }
  }
}
